import { render, staticRenderFns } from "./ContactViewCategories.vue?vue&type=template&id=9fce0d62"
import script from "./ContactViewCategories.vue?vue&type=script&lang=js"
export * from "./ContactViewCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports